import { createRouter, createWebHistory } from 'vue-router';
import NotFound from '../views/404';

const routes = [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "layout" */ '../layouts/BasicLayout'),

    children: [
      {
        path: '/',
        redirect: '/home',
      },
      {
        path: '/home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home'),
      },
      //投稿
      {
        path: '/lease',
        component: () => import('../views/Home/lease/lease.vue'),
      },
      {
        path: '/draft',
        component: () => import('../views/draft/draft.vue'),
      },
      {
        path: '/plan',
        component: () => import('../views/plan/plan.vue'),
      },
      {
        path: '/plan-list',
        component: () => import('../views/plan/plan-list.vue'),
      },
       //名家详情
      {
        path: '/celebrityDetails',
        component: () => import('../views/Celebrity/celebrityCpn/celebrityCard.vue'),
      },
       //名片详情(扫码进入的)
      {
        path: '/cardInfo',
        component: () => import('../views/user/card/cardInfo.vue'),
      },
    ],
  },

  //名家
  {
    path: '/celebrity',
    component: () => import('../views/Celebrity/celebrity.vue'),
  },
  //名家搜索
  {
    path: '/celebritySearch',
    component: () => import('../views/Celebrity/celebrityCpn/celebritySearch.vue'),
  },
  //我的
  {
    path: '/user',
    component: () => import('../views/user/user.vue'),
  },
  //歌曲搜索
  {
    path: '/musicSearch',
    component: () => import('../views/otherSearch/musicSearch.vue'),
  },
  //歌曲详情
  {
    path: '/musicDetails',
    component: () => import('../views/musicDetails/details.vue'),
  },
  //专题专辑详情
  {
    path: '/audiovisual',
    component: () => import('../views/audiovisualDetails/details.vue'),
  },
  // 专辑页
  {
    path: '/album',
    component: () => import('../views/Album/Album'),
  },
  // 专辑列表页
  {
    path: '/albumList',
    component: () => import('../views/Album/AlbumList.vue'),
  },
  // 视频播放页
  {
    path: '/myVideo',
    component: () => import('../views/myVideo/myVideo.vue'),
  },
  //用户信息页面
  {
    path: '/userInfo',
    component: () => import('../views/user/userCpn/userInfo.vue'),
  },
  //修改密码
  {
    path:'/changePassword',
    component: () => import('../views/user/modifyCpn/changePassword')
  },
  //修改用户信息
  {
    path:'/changeInfo',
    component: () => import('../views/user/modifyCpn/changeInfo')
  },
   //关于我们
   {
    path: '/about',
    component: () => import('../views/user/modifyCpn/about.vue'),
  },
  //绑定的手机
  {
    path: '/phone',
    component: () => import('../views/user/modifyCpn/phone'),
  },
  //用户做作品
  {
    path: '/userworks',
    component: () => import('../views/user/userCpn/userworks.vue'),
  },
  //我的名片
  {
    path: '/cardType',
    component: () => import('../views/user/userCpn/cardType.vue'),
  },
  //编辑名片列表
  {
    path: '/cardList',
    component: () => import('../views/user/card/cardList.vue'),
  },
  {
    path: '/deputy',
    component: () => import('../views/user/card/deputy.vue'),
  },
  //名片模板
  {
    path:'/cardTemplate',
    component:() => import('../views/user/card/cardTemplate.vue')
  },
   //自己查看名片可下载的中转页面
   {
    path:'/cardLoding',
    component:() => import('../views/user/card/cardLodding')
  },
  //编辑名片
  {
    path:'/editCard',
    component:() => import('../views/user/card/editCard.vue')
  },
  {
    path:'/downCard',
    component:() => import('../views/user/card/cardTem/downUserCard')
  },
  {
    path:'/downScore',
    component:() => import('../views/draft/draftCpn/downScore')
  },
  //消息列表
  {
    path:'/messageList',
    component:() => import('../views/user/modifyCpn/messageList.vue')
  },
  //自建专辑
  {
    path:'/myAlbum',
    component:() => import('../views/user/userCpn/myAlbum.vue')
  },
  //租赁详情
  {
    path:'/leaseDetail',
    component:() => import('../views/Home/lease/lease-detail.vue')
  },
  //评论页面
  {
    path:'/comment',
    component:() => import('../views/musicDetails/comment')
  },
  //我的需求页面
  {
    path:'/demand',
    component:() => import('../views/user/userCpn/demand.vue')
  },
  //我的投稿页面
  {
    path:'/submission',
    component:() => import('../views/user/userCpn/submission.vue')
  },
  {
    path:'/newsDetail',
    component:() => import('../views/user/newDetail.vue')
  },
  {
    path: '/register',
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/Register'),
  },

  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login'),
  },

  {
    path: '/wxauth',
    component: () => import(/* webpackChunkName: "wxauth" */ '../views/wxAuth'),
  },
  {
    path:'/paying',
    component:() => import('../views/pay/Paying'),
  },
  //最近预览页面
  {
    path:'/recentPreview',
    component:() => import('../views/user/recentPreview'),
  },
  //我的关注页面
  {
    path:'/attention',
    component:() => import('../views/user/attention'),
  },
  //我的专辑详情
  {
    path:'/myAlbumList',
    component:() => import('../views/user/userCpn/myAlbumList.vue'),
  },
  {
    path:'/order',
    component:() => import('../views/user/userCpn/myOrder'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
